<script setup lang="ts">
import type { IOrderStore } from '@sub/stores/order';
import { formatTime } from '@sub/utils/times';

const show = defineModel<boolean>('show')
const props = withDefaults(defineProps<{
  order?: IOrderStore,
  maxWidth?: string,
}>(), {
  order: () => ({}),
  maxWidth: '',
});

function close() {
  show.value = false;
}

const date = computed(() => props.order.dates ? `${formatDate(props.order.dates?.from, 'dd MMMM')} ${formatTime(props.order.dates?.from)} — ${formatTime(props.order.dates?.to)}` : '')

const emits = defineEmits(['order:keep', 'order:update']);

function onClick(event: 'order:keep' | 'order:update') {
  close();
  emits(event);
}
</script>

<template lang="pug">
UiModal(v-model:show="show" :maxWidth="maxWidth")
  template(v-slot:content)
    .flex-center-center.col-24.p-8-24-32
      UiImage.size-68.flex-shrink-0(src="/svg/calendar.svg" :border="false")
      .target.text-center.typ-16-20-400 {{ $t('page.booking.service.confirm.change.title') }}
      .flex.col-4.typ-13-17-300
        .target {{ $t('page.booking.service.confirm.change.desc.base') }}
        span.target
          slot
            | {{ order.service?.title }}
            template(v-if="order.dates")
              wbr
              | ,
              |
              span.white-space-nowrap {{ date }}
  template(v-slot:actions)
    UiButton.w-136(hierarchy="secondary" kind="outline" label="page.booking.service.confirm.change.button.cancel.text" @click="onClick('order:keep')")
    UiButton.w-136(hierarchy="primary" label="page.booking.service.confirm.change.button.confirm.text" @click="onClick('order:update')")
</template>

<style scoped lang="scss">
.target {
  color: #1F1F1F;
}
</style>